import { AvailabilitySlot } from "./generateStartTimes";

export const sortObjWithIsoStringKeyAsc = (inputObj: {[key: string]: AvailabilitySlot[]}) => {
    // Step 1: Extract keys, convert them to Date objects, and sort them
    const sortedKeys = Object.keys(inputObj).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());

    // Step 2: Create a new object with sorted keys
    const sortedObj: {[key: string]: AvailabilitySlot[]} = {};
    sortedKeys.forEach(key => {
      sortedObj[key] = inputObj[key];
    });
  
    return sortedObj;
}